import { Link } from './plyca-dtos';

export class PaginationInfo {
    public size: number;
    public totalElements: number;
    public totalPages: number;
    public number: number;
}

/**
 * Valor que tiene que ir en el valor del parametro size
 * para devolver un objeto paginado con todos los registros
 * Valor de PageableHandlerMethodArgumentResolver.DEFAULT_MAX_PAGE_SIZE
 */
export const ALL_ELEMENTS_SIZE = '2000';

export class PaginationDTO<T> {
    public links: Link[];
    public content: T[];
    public page: PaginationInfo;

}

